module.exports = require('./dist/feature-flags');
